<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="toc">
<div epub:type="bodymatter">
<section epub:type="division">
<h1 class="toc"><a id="pagevii"></a><em>Contents</em></h1>
<p class="center sans"><a href="#/Text/9781454928003_epub_itr_r1#itr"><span class="small">INTRODUCTION</span></a></p>
<p class="center"><a href="#/Text/9781454928003_epub_c01_r1#c01"><em>Chapter One</em><br/><span class="small"><span class="sans">ANTIPASTI</span></span><br/><em>(Antipasti)</em></a></p>
<p class="center"><span href="#/Text/9781454928003_epub_c02_r1#c02" title="Link target outside of Sample"><em>Chapter Two</em><br/><span class="small"><span class="sans">PASTAS AND RISOTTOS</span></span><br/><em>(Primi Piatti)</em></span></p>
<p class="center"><span href="#/Text/9781454928003_epub_c03_r1#c03" title="Link target outside of Sample"><em>Chapter Three</em><br/><span class="small"><span class="sans">SOUPS</span></span><br/><em>(Minestre)</em></span></p>
<p class="center"><span href="#/Text/9781454928003_epub_c04_r1#c04" title="Link target outside of Sample"><em>Chapter Four</em><br/><span class="small"><span class="sans">SIDE DISHES</span></span><br/><em>(Contorni)</em></span></p>
<p class="center"><span href="#/Text/9781454928003_epub_c05_r1#c05" title="Link target outside of Sample"><em>Chapter Five</em><br/><span class="small"><span class="sans">MEATS AND SEAFOOD</span></span><br/><em>(Secondi Piatti)</em></span></p>
<p class="center"><span href="#/Text/9781454928003_epub_c06_r1#c06" title="Link target outside of Sample"><em>Chapter Six</em><br/><span class="small"><span class="sans">DESSERTS</span></span><br/><em>(Dolci)</em></span></p>
<p class="center"><span href="#/Text/9781454928003_epub_c07_r1#c07" title="Link target outside of Sample"><em>Chapter Seven</em><br/><span class="small"><span class="sans">SAUCES, CONDIMENTS, AND PRESERVES</span></span><br/><em>(Salse, Condimenti e Conserve)</em></span></p>
<p class="center sans"><span href="#/Text/9781454928003_epub_bm1_r1#bm1" title="Link target outside of Sample"><span class="small">IN THE END</span></span></p>
<p class="center sans"><span href="#/Text/9781454928003_epub_ack_r1#ack" title="Link target outside of Sample"><span class="small">ACKNOWLEDGMENTS</span></span></p>
<p class="center sans"><span href="#/Text/9781454928003_epub_bm2_r1#bm2" title="Link target outside of Sample"><span class="small">METRIC CHART</span></span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454928003_epub_toc_r1.vue?45f0be8b